// Cadeaux offerts automatiquement selon le montant du panier (voir app/giftRules.server.ts +
// extensions/gift-with-purchase côté app). Deux responsabilités bien séparées :
// 1) syncGiftCart() : ajoute/retire les lignes cadeau via l'API panier Shopify standard, piloté
//    par interception fetch (indépendant du rendu DOM, fonctionne quel que soit le thème).
// 2) applyGiftUI() : masque le sélecteur de quantité et affiche un badge "Offert" sur les lignes
//    cadeau, piloté par un MutationObserver (le rendu du panier/tiroir peut être réinjecté en DOM
//    après la fin de notre propre fetch, l'observer garantit qu'on l'attrape quand même).
(function () {
  var RULES_ENDPOINT = "/apps/loyalty/gift-rules";
  var rules = null; // [{ minAmount, variantId: numeric string }]
  var rulesPromise = null;

  function loadRules() {
    if (rulesPromise) return rulesPromise;
    rulesPromise = fetch(RULES_ENDPOINT)
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        rules = (data.rules || []).map(function (r) {
          return { minAmount: r.minAmount, variantId: String(r.variantId).split("/").pop() };
        });
        return rules;
      })
      .catch(function () {
        rules = [];
        return rules;
      });
    return rulesPromise;
  }

  function ruleForVariant(variantId) {
    if (!rules) return null;
    var id = String(variantId);
    for (var i = 0; i < rules.length; i++) {
      if (rules[i].variantId === id) return rules[i];
    }
    return null;
  }

  var syncInFlight = null;
  function syncGiftCart() {
    if (syncInFlight) return syncInFlight;
    syncInFlight = loadRules()
      .then(function (r) {
        if (!r || r.length === 0) return;
        return fetch("/cart.js")
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            return applyCartCorrections(cart);
          });
      })
      .catch(function () {})
      .finally(function () {
        syncInFlight = null;
      });
    return syncInFlight;
  }

  function applyCartCorrections(cart) {
    var giftLinesTotal = 0;
    // Toutes les lignes existantes par variante (tableau, pas juste la dernière trouvée) : un
    // add.js concurrent (deux mutations panier rapprochées, ex. sync qui se redéclenche sur son
    // propre appel réseau) peut créer deux lignes distinctes pour le même cadeau. Si on ne
    // retenait que la dernière, l'autre resterait orpheline — jamais gratuite, jamais nettoyée.
    var giftLinesByVariant = {};
    cart.items.forEach(function (item) {
      var rule = ruleForVariant(item.variant_id);
      if (rule) {
        // final_line_price (pas original_line_price) : cart.total_price est déjà net de remise, et
        // une ligne cadeau est déjà à 0 grâce à la Function. Soustraire le prix plein tarif ici
        // reviendrait à l'exclure deux fois et sous-estimerait le sous-total qualifiant.
        giftLinesTotal += item.final_line_price;
        (giftLinesByVariant[rule.variantId] = giftLinesByVariant[rule.variantId] || []).push(item);
      }
    });
    var qualifyingSubtotal = (cart.total_price - giftLinesTotal) / 100;

    // Regroupe les règles par variante : plusieurs paliers peuvent offrir le même produit
    // (ex: 30€ -> 1 kit, 40€ -> 2 kits). La quantité offerte doit cumuler tous les paliers
    // atteints pour cette variante, pas se limiter à 1 — sinon la Function (qui, elle, cumule
    // déjà côté remise) ne trouve jamais assez d'unités en ligne à rendre gratuites.
    var rulesByVariant = {};
    rules.forEach(function (rule) {
      (rulesByVariant[rule.variantId] = rulesByVariant[rule.variantId] || []).push(rule);
    });

    var toAdd = [];
    var updates = {};
    var needsUpdate = false;

    Object.keys(rulesByVariant).forEach(function (variantId) {
      var qualifyingCount = rulesByVariant[variantId].filter(function (rule) {
        return qualifyingSubtotal >= rule.minAmount;
      }).length;
      var existingLines = giftLinesByVariant[variantId] || [];
      var primary = existingLines[0];
      var extras = existingLines.slice(1);

      if (qualifyingCount > 0 && !primary) {
        toAdd.push({ variantId: variantId, quantity: qualifyingCount });
      } else if (qualifyingCount === 0 && primary && primary.quantity > 0) {
        updates[primary.key] = 0;
        needsUpdate = true;
      } else if (qualifyingCount > 0 && primary && primary.quantity !== qualifyingCount) {
        updates[primary.key] = qualifyingCount;
        needsUpdate = true;
      }
      // Toute ligne dupliquée au-delà de la première est toujours superflue : on consolide sur une
      // seule ligne, quel que soit qualifyingCount, pour ne jamais laisser un doublon en vente.
      extras.forEach(function (extra) {
        if (extra.quantity > 0) {
          updates[extra.key] = 0;
          needsUpdate = true;
        }
      });
    });

    var chain = Promise.resolve();
    if (needsUpdate) {
      chain = chain.then(function () {
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: updates }),
        });
      });
    }
    toAdd.forEach(function (add) {
      chain = chain.then(function () {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [{ id: parseInt(add.variantId, 10), quantity: add.quantity, properties: { Cadeau: "Offert 🎁" } }],
          }),
        }).catch(function () {});
      });
    });
    // Quand un cadeau vient d'être ajouté ou retiré, le panier affiché date d'AVANT ce changement :
    // le mini-panier ouvert ne montrait pas la ligne cadeau (26 oct. 2026). On le recharge, et sur la
    // page /cart on recharge la page (une seule fois : au rechargement, plus rien n'est à corriger).
    if (toAdd.length || needsUpdate) {
      chain = chain.then(refreshDisplayedCart);
    }
    return chain;
  }

  function refreshDisplayedCart() {
    var path = window.location.pathname;
    if (path === "/cart" || path === "/cart/") {
      window.location.reload();
      return;
    }
    var el = document.getElementById("form-mini-cart");
    if (!el) return;
    return fetch("/?sections=form-mini-cart")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data["form-mini-cart"];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var form = doc.querySelector("#form-mini-cart");
        if (!form) return;
        // Même reconstruction que renderMiniCartSection (assets/product.js) : barre livraison et
        // encart cross-sell sont des frères qui précèdent #form-mini-cart.
        var deliv = doc.querySelector("[data-ads-delivery]");
        var upsell = doc.querySelector(".ads-cart-upsell");
        el.innerHTML = (deliv ? deliv.outerHTML : "") + (upsell ? upsell.outerHTML : "") + form.innerHTML;
        var cn = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        if (cn && typeof cn.cartAction === "function") cn.cartAction();
        return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll(".cart-count").forEach(function (c) {
            c.innerHTML = c.classList.contains("cart-count-drawer") ? "(" + cart.item_count + ")" : cart.item_count;
          });
        });
      })
      .catch(function () {});
  }

  // --- Habillage visuel des lignes cadeau (badge + quantité verrouillée) ---

  var STYLE_ID = "gift-with-purchase-style";
  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent =
      ".gift-with-purchase-badge{display:inline-flex;align-items:center;gap:4px;font-size:12px;" +
      "font-weight:600;color:#8A7A5C;background:rgba(138,122,92,.12);border-radius:20px;" +
      "padding:3px 10px;white-space:nowrap;}";
    document.head.appendChild(style);
  }

  var QUANTITY_SELECTORS = [".cart-item__quantity-wrapper", ".bls-minicart-actions", "quantity-input"];

  function applyGiftUI() {
    if (!rules || rules.length === 0) return;
    var rows = document.querySelectorAll("[data-variant-id]");
    rows.forEach(function (row) {
      var variantId = String(row.getAttribute("data-variant-id") || "").split("/").pop();
      var rule = ruleForVariant(variantId);
      if (!rule) return;
      if (row.dataset.giftApplied === "true") return;

      for (var i = 0; i < QUANTITY_SELECTORS.length; i++) {
        var el = row.querySelector(QUANTITY_SELECTORS[i]);
        if (el) {
          el.style.display = "none";
          var badge = document.createElement("span");
          badge.className = "gift-with-purchase-badge";
          badge.textContent = "🎁 Offert";
          el.insertAdjacentElement("afterend", badge);
          row.dataset.giftApplied = "true";
          break;
        }
      }
    });
  }

  var observerScheduled = false;
  function scheduleUIPass() {
    if (observerScheduled) return;
    observerScheduled = true;
    requestAnimationFrame(function () {
      observerScheduled = false;
      applyGiftUI();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    injectStyles();
    loadRules().then(function () {
      syncGiftCart();
      applyGiftUI();
    });

    new MutationObserver(scheduleUIPass).observe(document.body, { childList: true, subtree: true });
  });

  // Intercepte les appels panier standards de Shopify, quel que soit le thème/section qui les
  // déclenche, pour recalculer les cadeaux à chaque changement.
  var originalFetch = window.fetch;
  window.fetch = function () {
    var result = originalFetch.apply(this, arguments);
    var url = arguments[0] instanceof Request ? arguments[0].url : arguments[0];
    if (typeof url === "string" && /\/cart\/(change|update|add|clear)(\.js)?/.test(url)) {
      result.then(function () {
        syncGiftCart();
      });
    }
    return result;
  };
})();
